import {Link} from "react-router-dom";
import {Copy} from 'lucide-react';
import dayjs, {Dayjs} from "dayjs";
import {DatePicker, Tag, Tooltip} from "antd";
import usePeriodPresets from "../../optionsComponents/usePeriodOptions";
import {copyToClipboardUtils, transactionStatusToColorFormatter} from "../../utils";
import {LogsStatusIcon} from "../../utils/statusIcons";

const {RangePicker} = DatePicker;

const ClickS2PLogsColumns = (t, handleChangePeriod, copyToClipboard) => {
    const disabledDate = (current: Dayjs) => {
        return dayjs().add(1, 'day') < current;
    };

    return [
        {
            title: "",
            key: "copy",
            render: (_, record) => (
                <Tooltip key={record.id} title="Copy row data to Clipboard">
                    <Copy
                        size={14}
                        style={{cursor: "pointer", color: "gray"}}
                        onClick={() => copyToClipboardUtils("Scan2Pay Log", record)}
                    />
                </Tooltip>
            ),
        },
        {
            title: t('pages.logs.listColumns.column1'),
            dataIndex: 'status',
            render: (text, record) => (
                <>
                    {[record.status].map(tag => (
                        <LogsStatusIcon key={tag} size={18} status={tag}/>
                    ))}
                </>
            ),
            orderIndex: "status",
            filters: [
                {text: 'PROCESSING', value: 'PROCESSING'},
                {text: 'SUCCESS', value: 'SUCCESS'},
                {text: 'FISCALIZED', value: 'FISCALIZED'},
                {text: 'FAILED', value: 'FAILED'},
                {text: 'CANCELED', value: 'CANCELED'},
            ],
            filterMultiple: false,
            onFilter: (value, record) => record.status === value,
        },
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('pages.logs.listColumns.column2')}
                </span>
            ),
            dataIndex: 'deviceSerial',
            render: (text, record) => (
                <Link to={`/s2p/click/logs/detail/${record.key}`}>{text}</Link>
            ),
            // sorter: true,
            // orderIndex: "device_serial",
        },
        {
            title: t('pages.logs.listColumns.column3'),
            dataIndex: 'company_name',
        },
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('pages.logs.listColumns.column10')}
                </span>
            ),
            dataIndex: 'uuid',
            render: (text, record) => (
                <Link to={`/s2p/click/logs/detail/${record.key}`}>{text}</Link>
            ),
        },
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('pages.logs.listColumns.column4')}
                </span>
            ),
            dataIndex: 'paymentId',
            render: (text, record) => (
                <Link to={`/s2p/click/logs/detail/${record.key}`}>{text}</Link>
            ),
        },
        {
            title: t('pages.logs.listColumns.column5'),
            dataIndex: 'amount_in_sums',
            sorter: true,
            orderIndex: "amount_in_sums",
            render: (text, record) => (
                <Tag
                    color={transactionStatusToColorFormatter(record.status)}
                    key={record.amount_in_sums}
                >
                    {`${String(record.amount_in_sums)}`.toUpperCase()}
                </Tag>
            ),
        },
        {
            title: t('pages.logs.listColumns.column7'),
            dataIndex: 'createdDate',
            orderIndex: "created_date",
            sorter: true,
            filterDropdown: () => (
                <div style={{padding: 8}}>
                    <RangePicker
                        presets={usePeriodPresets}
                        onChange={handleChangePeriod}
                        disabledDate={disabledDate}
                        allowClear={true}
                        style={{marginBottom: 16}}
                        placeholder={[`${t("common.filter.dateFilter1")}`, `${t("common.filter.dateFilter2")}`]}
                    />
                </div>
            ),
        },
    ];
};

export default ClickS2PLogsColumns;
